export const getIsEmploymentLoaded = state => !!state.employment.employment;
export const getEmployment = state => state.employment.employment;
export const getIsSubmitting = state => state.employment.isSubmitting;
export const getFormError = state => state.employment.error;
export const getIsReadOnly = state => state.employment.isReadOnly;
